import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import UserList from '../../components/DashBoard/UserList/UserList'
import Meta from '../../components/Helmet/Meta'
import SideBarComponents from '../../components/SideBar/SideBarComponents'
import './dashboard.css'

const UserListScreendas = () => {
    return (
        <div className="main"  fluid >
            <Meta
                title=" | Admin Users"
            />
            
            <Container fluid>
                <Row>
                    <Col md={3}>
                        <h4> Utilisateurs</h4>
                    </Col>
                    <Col md={9}>
                        <h4 > liste d'utilisateur </h4>
                    </Col>
                </Row>
                <Row>
                    <Col md={3}>
                        <SideBarComponents />
                    </Col>
                    <Col md={9}>
                        <UserList />
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default UserListScreendas
